import { render, staticRenderFns } from "./Renglonaje.vue?vue&type=template&id=ef4a29ce&scoped=true&"
import script from "./Renglonaje.vue?vue&type=script&lang=js&"
export * from "./Renglonaje.vue?vue&type=script&lang=js&"
import style0 from "./Renglonaje.vue?vue&type=style&index=0&id=ef4a29ce&prod&scoped=true&lang=css&"
import style1 from "./Renglonaje.vue?vue&type=style&index=1&id=ef4a29ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a29ce",
  null
  
)

export default component.exports